import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[Invite SetFilter] Action',
  ResetFilter: '[Invite ResetFilter] Action',
}

const initialInviteState: IInviteState = {
  filter: {
    status: 'pending',
  },
}

export interface IInviteState {
  filter?: {
    status: string
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-Invite', whitelist: ['filter']},
  (state: IInviteState = initialInviteState, action: ActionWithPayload<IInviteState>) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialInviteState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
